import { client, ApolloProvider } from '@/src/utils/datalayer/apolloClient'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export default function ApolloProviderWrapper({ children }: Props) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
